module.exports = __webpack_public_path__ + "static/media/eva-chi.28de872d.png";